<template>
  <div>
    <div class="actions nowrap">
      <div v-for="(veiksmas, index) in veiksmai1" :key="index">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              :disabled="loading"
              @click="selectVeiksmas(veiksmas)"
            >
              {{ veiksmas.icon }}
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ veiksmas.title }}
          </div>
        </v-tooltip>
      </div>
    </div>
    <div class="actions nowrap">
      <div v-for="(veiksmas, index) in veiksmai2" :key="index">
        <template v-if="veiksmas.button">
          <el-button
            x-small
            :primary="veiksmas.primary"
            :disabled="loading"
            @click.native="selectVeiksmas(veiksmas)"
            >{{ veiksmas.title }}</el-button
          >
        </template>
        <template v-if="!veiksmas.button">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                dense
                class="table-action mx-1"
                v-bind="attrs"
                v-on="on"
                :disabled="loading"
                @click="selectVeiksmas(veiksmas)"
              >
                {{ veiksmas.icon }}
              </v-icon>
            </template>
            <div class="tooltip-text">
              {{ veiksmas.title }}
            </div>
          </v-tooltip>
        </template>
      </div>
    </div>
    <div class="actions">
      <div v-for="(veiksmas, index) in veiksmai3" :key="index">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              dense
              class="table-action mx-1"
              v-bind="attrs"
              v-on="on"
              :disabled="loading"
              @click="selectVeiksmas(veiksmas)"
            >
              {{ veiksmas.icon }}
            </v-icon>
          </template>
          <div class="tooltip-text">
            {{ veiksmas.title }}
          </div>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElSavitarnaAction',
  props: {
    item: Object,
    loading: { type: Boolean, default: false },
  },
  computed: {
    veiksmai1() {
      return this.item.veiksmasList.filter(veiksmas => veiksmas.group === 1)
    },
    veiksmai2() {
      return this.item.veiksmasList.filter(veiksmas => veiksmas.group === 2)
    },
    veiksmai3() {
      return this.item.veiksmasList.filter(veiksmas => veiksmas.group === 3)
    },
  },
  methods: {
    selectVeiksmas(veiksmas) {
      this.$emit('savitarnaAction', this.item, veiksmas)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-action {
  line-height: 24px;
}
.table-action:hover {
  color: var(--v-primary-base);
}
.actions div {
  display: inline-flex;
  line-height: 24px;
}
</style>
